export const categories = [
  { slug: 'romance', name: '恋爱甜宠', icon: 'ri-heart-line' },
  { slug: 'fantasy', name: '奇幻冒险', icon: 'ri-magic-line' },
  { slug: 'action', name: '热血动作', icon: 'ri-fire-line' },
  { slug: 'drama', name: '都市剧情', icon: 'ri-building-line' },
  { slug: 'thriller', name: '悬疑惊悚', icon: 'ri-ghost-line' },
  { slug: 'comedy', name: '搞笑日常', icon: 'ri-emotion-laugh-line' },
  { slug: 'historical', name: '古风穿越', icon: 'ri-ancient-gate-line' },
  { slug: 'school', name: '校园青春', icon: 'ri-book-open-line' },
];

export const comics = [
  {
    id: 1,
    title: '霸总的契约新娘',
    slug: 'ceo-contract-bride',
    category: 'romance',
    cover: 'https://readdy.ai/api/search-image?query=A%20stunning%20Korean%20webtoon%20style%20illustration%20of%20a%20handsome%20CEO%20man%20in%20a%20sharp%20dark%20suit%20holding%20a%20beautiful%20woman%20in%20an%20elegant%20white%20dress%2C%20soft%20romantic%20atmosphere%2C%20pastel%20pink%20and%20cream%20color%20palette%2C%20delicate%20lighting%2C%20clean%20background%20with%20subtle%20cherry%20blossom%20petals%2C%20modern%20manhwa%20art%20style%2C%20emotive%20expressions%2C%20cinematic%20composition&width=400&height=540&seq=comic-01&orientation=portrait',
    author: '星野漫',
    status: 'ongoing',
    rating: 9.5,
    views: 1280000,
    summary: '为救家族企业，她被迫嫁给冷酷总裁。原以为是一场交易婚姻，却不知他早已暗恋她多年。当真相一层层揭开，契约婚姻竟变成最甜蜜的陷阱...',
    tags: ['总裁', '契约婚姻', '先婚后爱', '甜宠'],
    updatedAt: '2026-08-03',
    chapters: Array.from({ length: 87 }, (_, i) => ({ number: 87 - i, title: i === 0 ? `第${87 - i}话：最后的告白` : i === 1 ? `第${87 - i}话：真相大白` : `第${87 - i}话` })),
  },
  {
    id: 2,
    title: '剑与魔法的轮回',
    slug: 'sword-and-magic-reincarnation',
    category: 'fantasy',
    cover: 'https://readdy.ai/api/search-image?query=A%20breathtaking%20Korean%20webtoon%20style%20fantasy%20illustration%20of%20a%20male%20warrior%20wielding%20a%20glowing%20sword%20surrounded%20by%20magic%20energy%2C%20epic%20fantasy%20backdrop%20with%20ancient%20ruins%20and%20floating%20crystals%2C%20dramatic%20lighting%20with%20golden%20and%20teal%20accents%2C%20modern%20manhwa%20art%20style%2C%20dynamic%20pose%2C%20clean%20composition&width=400&height=540&seq=comic-02&orientation=portrait',
    author: '影刃',
    status: 'ongoing',
    rating: 9.7,
    views: 2560000,
    summary: '顶级剑士在最终决战中陨落，却意外重生回十年前。带着前世所有的记忆和战斗经验，他要改写命运，阻止即将到来的灾厄。这一次，他不会再让任何人牺牲。',
    tags: ['重生', '剑士', '魔法', '战斗', '复仇'],
    updatedAt: '2026-08-04',
    chapters: Array.from({ length: 124 }, (_, i) => ({ number: 124 - i, title: `第${124 - i}话` })),
  },
  {
    id: 3,
    title: '暗夜追踪者',
    slug: 'night-tracker',
    category: 'thriller',
    cover: 'https://readdy.ai/api/search-image?query=A%20moody%20Korean%20webtoon%20style%20thriller%20illustration%20of%20a%20detective%20in%20a%20dark%20trench%20coat%20standing%20under%20a%20flickering%20streetlamp%20in%20a%20rainy%20alley%2C%20noir%20atmosphere%2C%20deep%20shadows%2C%20monochrome%20with%20selective%20red%20accents%2C%20modern%20manhwa%20art%20style%2C%20cinematic%20composition&width=400&height=540&seq=comic-03&orientation=portrait',
    author: '夜墨',
    status: 'completed',
    rating: 9.3,
    views: 890000,
    summary: '连续发生的失踪案件让整座城市陷入恐慌。天才侧写师林寒接手调查，却发现每一条线索都指向十年前那桩已经被"解决"的悬案。真相远比想象中更加黑暗...',
    tags: ['悬疑', '推理', '犯罪', '心理'],
    updatedAt: '2026-07-15',
    chapters: Array.from({ length: 56 }, (_, i) => ({ number: 56 - i, title: `第${56 - i}话` })),
  },
  {
    id: 4,
    title: '我的ID是江南美人',
    slug: 'my-id-is-gangnam-beauty',
    category: 'school',
    cover: 'https://readdy.ai/api/search-image?query=A%20charming%20Korean%20webtoon%20style%20campus%20illustration%20of%20a%20beautiful%20female%20college%20student%20with%20long%20hair%20smiling%20shyly%20against%20a%20sunny%20university%20campus%20backdrop%2C%20warm%20spring%20atmosphere%2C%20cherry%20blossoms%2C%20soft%20pastel%20color%20palette%2C%20modern%20manhwa%20art%20style%2C%20youthful%20and%20fresh%20vibe&width=400&height=540&seq=comic-04&orientation=portrait',
    author: '花间集',
    status: 'completed',
    rating: 9.4,
    views: 3100000,
    summary: '因为外貌从小被嘲笑的她，在大学入学前做了整容手术。变成了"江南美人"的她以为可以重新开始，却没想到美貌带来的麻烦比想象的多得多...她能否找到真正欣赏她内在的人？',
    tags: ['校园', '恋爱', '成长', '整容', '治愈'],
    updatedAt: '2026-06-20',
    chapters: Array.from({ length: 98 }, (_, i) => ({ number: 98 - i, title: `第${98 - i}话` })),
  },
  {
    id: 5,
    title: '逆天邪神',
    slug: 'against-the-gods',
    category: 'action',
    cover: 'https://readdy.ai/api/search-image?query=An%20intense%20Korean%20webtoon%20style%20action%20illustration%20of%20a%20powerful%20male%20fighter%20with%20flaming%20fists%20in%20a%20dynamic%20battle%20pose%2C%20energy%20auras%20surrounding%20him%2C%20epic%20martial%20arts%20theme%2C%20dramatic%20orange%20and%20red%20lighting%2C%20modern%20manhwa%20art%20style%2C%20clean%20background%20with%20speed%20lines&width=400&height=540&seq=comic-05&orientation=portrait',
    author: '烈火',
    status: 'ongoing',
    rating: 9.6,
    views: 4800000,
    summary: '被人陷害跌落山崖的少年，意外获得上古神族传承。从此，他踏上了一条逆天改命的修行之路。诸天万界，唯我独尊——且看少年如何一步步登临巅峰！',
    tags: ['热血', '修仙', '战斗', '逆袭', '玄幻'],
    updatedAt: '2026-08-04',
    chapters: Array.from({ length: 312 }, (_, i) => ({ number: 312 - i, title: `第${312 - i}话` })),
  },
  {
    id: 6,
    title: '办公室的秘密',
    slug: 'office-secrets',
    category: 'drama',
    cover: 'https://readdy.ai/api/search-image?query=A%20stylish%20Korean%20webtoon%20style%20office%20drama%20illustration%20of%20a%20confident%20woman%20in%20a%20chic%20business%20outfit%20standing%20in%20a%20modern%20office%20with%20glass%20walls%2C%20city%20skyline%20visible%20through%20windows%2C%20sophisticated%20atmosphere%2C%20warm%20neutral%20color%20palette%2C%20modern%20manhwa%20art%20style&width=400&height=540&seq=comic-06&orientation=portrait',
    author: '城市漫画家',
    status: 'ongoing',
    rating: 9.1,
    views: 760000,
    summary: '新来的实习生发现看似和谐的办公室里，每个人都藏着不为人知的秘密。职场生存、爱情纠葛、利益博弈——在这座玻璃大楼里，每一天都是一场没有硝烟的战争。',
    tags: ['职场', '都市', '恋爱', '权谋'],
    updatedAt: '2026-08-02',
    chapters: Array.from({ length: 45 }, (_, i) => ({ number: 45 - i, title: `第${45 - i}话` })),
  },
  {
    id: 7,
    title: '鬼医王妃',
    slug: 'ghost-doctor-princess',
    category: 'historical',
    cover: 'https://readdy.ai/api/search-image?query=An%20elegant%20Korean%20webtoon%20style%20historical%20illustration%20of%20a%20beautiful%20woman%20in%20traditional%20hanbok%20holding%20a%20small%20medicine%20bottle%20in%20an%20ancient%20palace%20courtyard%2C%20soft%20traditional%20Korean%20aesthetic%2C%20warm%20golden%20and%20jade%20green%20tones%2C%20modern%20manhwa%20art%20style%2C%20graceful%20composition&width=400&height=540&seq=comic-07&orientation=portrait',
    author: '墨染青衫',
    status: 'ongoing',
    rating: 9.5,
    views: 1950000,
    summary: '现代顶级外科医生魂穿古代，成为不受宠的废王妃子。凭借一手绝世医术，她在这暗流涌动的深宫中步步为营。当冷酷王爷逐渐对她另眼相看，她能否在权谋与爱情中找到自己的归宿？',
    tags: ['穿越', '古风', '医术', '王妃', '逆袭'],
    updatedAt: '2026-08-03',
    chapters: Array.from({ length: 156 }, (_, i) => ({ number: 156 - i, title: `第${156 - i}话` })),
  },
  {
    id: 8,
    title: '逗比室友日常',
    slug: 'funny-roommate-daily',
    category: 'comedy',
    cover: 'https://readdy.ai/api/search-image?query=A%20playful%20Korean%20webtoon%20style%20comedy%20illustration%20of%20two%20college%20students%20sharing%20a%20messy%20dorm%20room%2C%20exaggerated%20funny%20expressions%2C%20bright%20and%20lively%20atmosphere%2C%20colorful%20posters%20on%20walls%2C%20warm%20indoor%20lighting%2C%20modern%20manhwa%20art%20style%2C%20chaotic%20and%20fun%20vibe&width=400&height=540&seq=comic-08&orientation=portrait',
    author: '爆笑君',
    status: 'ongoing',
    rating: 9.2,
    views: 2100000,
    summary: '两个性格天差地别的大学生被迫成为室友——一个是重度洁癖的学霸，一个是邋遢到极致的艺术家。从互相嫌弃到成为最佳损友，365天不间断的爆笑日常，保证让你笑到肚子疼！',
    tags: ['搞笑', '校园', '日常', '友情'],
    updatedAt: '2026-08-01',
    chapters: Array.from({ length: 203 }, (_, i) => ({ number: 203 - i, title: `第${203 - i}话` })),
  },
  {
    id: 9,
    title: '月光奏鸣曲',
    slug: 'moonlight-sonata',
    category: 'romance',
    cover: 'https://readdy.ai/api/search-image?query=A%20dreamy%20Korean%20webtoon%20style%20romance%20illustration%20of%20a%20pianist%20man%20playing%20piano%20under%20moonlight%20with%20a%20woman%20listening%20closely%2C%20romantic%20night%20atmosphere%2C%20silver%20moonlight%20streaming%20through%20a%20large%20window%2C%20soft%20blue%20and%20silver%20color%20palette%2C%20modern%20manhwa%20art%20style&width=400&height=540&seq=comic-09&orientation=portrait',
    author: '月色漫画家',
    status: 'ongoing',
    rating: 9.8,
    views: 3600000,
    summary: '失聪的钢琴天才与热爱音乐的聋哑女孩，在音乐学院的天台上因一段无声的旋律相遇。他用琴键诉说心意，她用手语回应温柔——这是一部关于音乐、梦想与纯粹爱情的故事，无关声音，只关心灵。',
    tags: ['音乐', '恋爱', '治愈', '纯爱', '校园'],
    updatedAt: '2026-08-04',
    chapters: Array.from({ length: 78 }, (_, i) => ({ number: 78 - i, title: `第${78 - i}话` })),
  },
  {
    id: 10,
    title: '末日生存法则',
    slug: 'apocalypse-survival',
    category: 'action',
    cover: 'https://readdy.ai/api/search-image?query=A%20gritty%20Korean%20webtoon%20style%20post%20apocalyptic%20illustration%20of%20a%20female%20survivor%20with%20a%20determined%20expression%20holding%20a%20makeshift%20weapon%20in%20a%20ruined%20cityscape%2C%20desolate%20atmosphere%2C%20muted%20earthy%20colors%20with%20pops%20of%20red%2C%20modern%20manhwa%20art%20style%2C%20cinematic%20widescreen%20composition&width=400&height=540&seq=comic-10&orientation=portrait',
    author: '末日绘师',
    status: 'ongoing',
    rating: 9.4,
    views: 1750000,
    summary: '病毒爆发后，世界沦为废墟。普通上班族苏瑶在末日中挣扎求生，意外觉醒了异能。为了找到失散的妹妹，她必须穿越满是变异者的城市。在这个弱肉强食的新世界里，信任是最奢侈的东西。',
    tags: ['末日', '生存', '异能', '冒险', '热血'],
    updatedAt: '2026-08-03',
    chapters: Array.from({ length: 67 }, (_, i) => ({ number: 67 - i, title: `第${67 - i}话` })),
  },
  {
    id: 11,
    title: '替身新娘',
    slug: 'substitute-bride',
    category: 'drama',
    cover: 'https://readdy.ai/api/search-image?query=An%20emotional%20Korean%20webtoon%20style%20drama%20illustration%20of%20a%20woman%20in%20a%20wedding%20dress%20looking%20at%20herself%20in%20a%20mirror%20with%20a%20complex%20expression%2C%20elegant%20bridal%20setting%2C%20soft%20romantic%20lighting%2C%20pastel%20cream%20and%20rose%20tones%2C%20modern%20manhwa%20art%20style&width=400&height=540&seq=comic-11&orientation=portrait',
    author: '花间集',
    status: 'completed',
    rating: 9.0,
    views: 1500000,
    summary: '姐姐在婚礼前逃跑，她被家族逼迫代替姐姐嫁给从未谋面的豪门继承人。本以为会是一场灾难，却在新婚夜发现新郎竟然是自己暗恋多年的学长...命运的玩笑，让替身变成了正主。',
    tags: ['替身', '先婚后爱', '豪门', '甜宠'],
    updatedAt: '2026-05-10',
    chapters: Array.from({ length: 72 }, (_, i) => ({ number: 72 - i, title: `第${72 - i}话` })),
  },
  {
    id: 12,
    title: '学霸的秘密笔记',
    slug: 'genius-secret-notes',
    category: 'school',
    cover: 'https://readdy.ai/api/search-image?query=A%20bright%20Korean%20webtoon%20style%20school%20illustration%20of%20a%20girl%20with%20glasses%20studying%20at%20a%20library%20desk%20surrounded%20by%20books%20and%20notes%2C%20sunlight%20streaming%20through%20large%20windows%2C%20warm%20academic%20atmosphere%2C%20soft%20beige%20and%20green%20tones%2C%20modern%20manhwa%20art%20style&width=400&height=540&seq=comic-12&orientation=portrait',
    author: '学海漫画家',
    status: 'ongoing',
    rating: 9.1,
    views: 680000,
    summary: '全校第一的学霸白若溪有一个秘密——她不是天生聪明，而是拥有一本能够预知考试题目的神秘笔记。当这个秘密被班上最不起眼的男生意外发现，她的平静校园生活彻底被打乱了。',
    tags: ['校园', '奇幻', '恋爱', '青春', '成长'],
    updatedAt: '2026-08-02',
    chapters: Array.from({ length: 34 }, (_, i) => ({ number: 34 - i, title: `第${34 - i}话` })),
  },
];

export const siteInfo = {
  name: '韩漫网',
  slogan: '精选韩漫，畅享阅读',
  description: '韩漫网致力于为广大漫画爱好者提供最新、最全、最优质的韩漫资源。我们与多家韩国漫画平台合作，实时同步更新，让您第一时间追更心仪的漫画。',
  founded: '2020年',
  email: 'contact@hanmanwang.com',
  address: '',
  stats: {
    totalComics: 5000,
    totalChapters: 150000,
    totalUsers: 2000000,
    dailyUpdates: 200,
  },
  features: [
    { title: '海量资源', description: '收录超过5000部精选韩漫，涵盖恋爱、奇幻、动作、悬疑等多种类型，满足不同读者的口味。', icon: 'ri-stack-line' },
    { title: '高清画质', description: '所有漫画均采用高清画质呈现，完美还原韩漫精美细腻的画风，带来极致的阅读体验。', icon: 'ri-hd-line' },
    { title: '实时更新', description: '与韩国平台同步更新，最新章节第一时间上线，让您不错过任何精彩内容。', icon: 'ri-refresh-line' },
    { title: '免费阅读', description: '海量韩漫免费在线观看，无需付费即可畅享阅读乐趣，让好漫画触手可及。', icon: 'ri-gift-line' },
    { title: '智能推荐', description: '基于您的阅读偏好智能推荐相似漫画，帮您发现更多值得一看的好作品。', icon: 'ri-lightbulb-line' },
    { title: '多端同步', description: '支持手机、平板、电脑多端同步阅读进度，随时随地继续您的漫画之旅。', icon: 'ri-device-line' },
  ],
  reviews: [
    { name: '漫画迷小雪', rating: 5, content: '这个网站真的太棒了！更新速度超快，画质也很清晰，我每天都要上来刷好几遍，强烈推荐给所有喜欢韩漫的朋友！', date: '2026-07-20' },
    { name: '追更达人阿杰', rating: 5, content: '找了很久终于找到了一个靠谱的韩漫网站，资源很全，分类很清晰，而且完全免费，真的是良心网站！', date: '2026-07-18' },
    { name: '小确幸', rating: 5, content: '页面设计简洁大方，阅读体验非常好。最重要的是更新及时，再也不用到处找资源了，一个网站搞定所有韩漫需求。', date: '2026-07-15' },
    { name: '漫画控小白', rating: 4, content: '漫画种类很丰富，从恋爱到奇幻应有尽有。如果能增加一些收藏和书签功能就更完美了，总的来说非常满意！', date: '2026-07-10' },
  ],
};

export const faqs = [
  { question: '韩漫网上的漫画都是免费的吗？', answer: '是的，韩漫网上的所有漫画均提供免费在线观看。我们致力于为漫画爱好者提供优质的免费阅读体验，无需付费即可畅享海量韩漫资源。' },
  { question: '漫画的更新频率是怎样的？', answer: '我们与韩国漫画平台保持同步更新，热门连载漫画通常每周更新1-2话。您可以在每部漫画的详情页查看具体的更新时间。' },
  { question: '如何在手机上阅读漫画？', answer: '韩漫网采用响应式设计，完美适配手机、平板和电脑等各类设备。您只需使用手机浏览器访问我们的网站，即可享受流畅的移动端阅读体验。' },
  { question: '可以下载漫画离线观看吗？', answer: '目前我们主要提供在线观看服务。为保护版权和创作者的权益，暂不支持下载功能。不过您随时可以在线访问，我们保证网站的稳定和快速。' },
  { question: '如何找到我想看的漫画类型？', answer: '您可以通过首页顶部的分类导航进入不同的漫画类型页面，也可以在搜索框中输入漫画名称或关键词进行查找。我们的智能推荐系统也会根据您的阅读偏好为您推荐相关作品。' },
];